<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">{{ $t('farmers') }}</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-header">
        <p-button class="btn btn-primary pull-right" @click="handleCreateModal">
          <i class="fa fa-plus"></i>{{ $t('new_farmer') }}
        </p-button>
        <!-- <div class="category">Forms</div> -->
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              placeholder="Search"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            ></fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table
            v-loading="loading"
            :element-loading-text="$t('loading_data')+'...'"
            class="table-striped"
            :data="queriedData"
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
            <el-table-column :min-width="120" fixed="right" class-name="td-actions text-center" :label="$t('actions')">
              <template slot-scope="props">
                <p-button
                  type="primary"
                  size="sm"
                  icon
                  @click="handleView(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </p-button>
                <p-button
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDelete(props.$index, props.row)"
                >
                  <i class="fa fa-trash"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-primary">
          <p class="category">{{ $t('showing') }} {{ from + 1 }} {{ $t('to') }} {{ to }} {{ $t('of') }} {{ total }} {{ $t('entries') }}</p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          ></p-pagination>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t('choose_template')}}</h4>
        <form>
          <fg-input>
            <el-select
              size="large"
              class="select-primary"
              filterable
              clearable
              v-model="form.pageTemplateID"
              :placeholder="$t('select_template')"
            >
              <el-option
                class="select-primary"
                v-for="pageTemplate in pageTemplates"
                :key="pageTemplate.id"
                :label="pageTemplate.title"
                :value="pageTemplate.id"
              ></el-option>
            </el-select>
          </fg-input>
        </form>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">{{ $t('cancel') }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="primary" link @click="createPage">{{ $t('continue') }}</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Sidebar from "src/sidebarLinks.js";

import { Message, Form } from "element-ui";
import Modal from "src/components/UIComponents/Modal.vue";

import Resource from "@/util/Api/resource.js";
import { fetchPageTemplateByCategory } from "@/util/Api/pageTemplate.js";
import { fetchPages } from "@/util/Api/page.js";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
  components: {
    PPagination,
    Modal
  },
  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        this.pagination.total = this.tableData.length;
        return this.pagedData;
      }
      let result = this.tableData.filter(row => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          let rowValue = row[key].toString();
          rowValue = rowValue.toLowerCase();
          this.searchQuery = this.searchQuery.toLowerCase();
          if (rowValue.includes && rowValue.includes(this.searchQuery)) {
            isIncluded = true;
          }
        }
        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      this.pagination.total = this.tableData.length;
      return this.tableData.length;
    }
  },
  data() {
    return {
      modals: {
        classic: false
      },
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [10, 20, 30, 60, 500, 1000],
        total: 0
      },
      searchQuery: "",

      propsToSearch: ["post.title"],

      tableColumns: [
        {
          prop: "post.title",
          label: this.$t("post_title"),
          minWidth: 200
        }
      ],

      tableData: [],
      loading: false,
      pageTemplates: [],
      form: {
        pageTemplateID: null,
      }
    };
  },
  created() {
    this.getPages();
    this.getPageTemplates();
  },
  methods: {
    handleCreateModal() {
      this.modals.classic = true;
    },
    handleCloseModal() {
      this.modals.classic = false;
    },
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },
    handleDelete(index, row) {
      this.$confirm(this.$t("are_you_sure_you_want_to_delete_this_form"), "Warning", {
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("cancel"),
        cancelButtonClass: "btn-danger",
        confirmButtonClass: "btn-primary",
        type: "warning"
      })
        .then(() => {
          let indexToDelete = this.tableData.findIndex(
            tableRow => tableRow.id === row.id
          );
          if (indexToDelete >= 0) {
            this.form = row;
            FormResource.destroy(this.form.id)
              .then(response => {
                this.tableData.splice(indexToDelete, 1);
                this.showAlertMessage(response.message, "success");
              })
              .catch(error => {});
          }
        })
        .catch(() => {});
    },
    handleView(index, row) {
      this.$router.push({
        name: "PageContentEdit",
        params: { pageTemplateID: row.pageTemplateID, pageID: row.id }
      });
    },
    async getPages() {
      this.loading = true;
      await fetchPages({})
        .then(response => {
          console.log('farmers', response.data);
          this.tableData = response.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async getPageTemplates() {
      await fetchPageTemplateByCategory("Farmer")
        .then(response => {
          this.pageTemplates = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    createPage() {
      this.modals.classic = false;
      this.$router.push({
        name: "FarmerContent",
        params: { id: this.form.pageTemplateID }
      });
    }
  }
};
</script>
<style lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
a.custom-link {
  background-color: #2c2c2c;
  padding: 20px;
  color: white;
  text-transform: uppercase;
  font-weight: 700;
}
a.custom-link:hover {
  background-color: #6bd098;
  color: white;
}

.modal-open {
  overflow: scroll;
}
</style>
